import FilterUtils from '@/shared/utils/filters';

export default class BillingFilterRequest {
  customerExternalId: string;

  customerIds: Array<string>;

  resultCenterId: string;

  competence: string;

  invoiceNumber: string;

  paymentDueAt: string;

  status: string;

  netValueOperator: string;

  netValue: string;

  dueDateStart: string;

  dueDateEnd: string;

  anniversary: string;

  beneficiary: string;

  product: Array<string>;

  discountedValueOperator: string;

  discountedValue: string;

  contractExternalId: number;

  invoicePaymentExternalIds: string;

  searchBy: string;

  searchValue: string;

  productId: number;

  frequency: string;

  constructor(obj: any) {
    this.customerExternalId = obj.customerExternalId || null;
    this.customerIds = obj.customerIds || [];
    this.resultCenterId = obj.resultCenterId || null;
    this.competence = obj.competence;
    this.invoiceNumber = obj.invoiceNumber || null;
    this.paymentDueAt = obj.paymentDueAt || null;
    this.status = obj.status || null;
    this.netValueOperator = obj.netValueOperator || null;
    this.dueDateStart = obj.dueDateStart || null;
    this.dueDateEnd = obj.dueDateEnd || null;
    this.anniversary = obj.anniversary || null;
    this.netValue = FilterUtils.formatValue(obj.netValue) || '';
    this.beneficiary = obj.beneficiary || null;
    this.product = obj.product || [];
    this.discountedValueOperator = obj.discountedValueOperator || null;
    this.discountedValue = FilterUtils.formatValue(obj.discountedValue) || '';
    this.contractExternalId = obj.contractExternalId;
    this.invoicePaymentExternalIds = obj.invoicePaymentExternalIds;
    this.searchBy = obj.searchBy || null;
    this.searchValue = obj.searchValue || null;
    this.productId = obj.productId;
    this.frequency = obj.frequency || '';
  }

  public static of(obj: any) {
    return new BillingFilterRequest(obj || {});
  }
}
